import React, { useState, useEffect, useContext, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import { Checkbox } from 'primereact/checkbox';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { AuthContext } from "../../../../Header/auth - context";
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { FileUpload } from 'primereact/fileupload';
import { Toast } from "primereact/toast";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { AutoComplete } from "primereact/autocomplete";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import CustomDropdown from '../../../../custom/customDropdown';
import handlePrint from './straneUgovora/ugovorStampa';
import { InputNumber } from "primereact/inputnumber";

const ZaposleniUnos = () => {
  const { t } = useTranslation();

    const auth = useContext(AuthContext);
    const formRef = useRef(null);
    const toast = useRef(null);
    const company = useSelector(state => state.company)
    const user = useSelector(state => state.user)
    const employee = useSelector(state => state.employee);
    const dispatch = useDispatch();
    const [idEmployee, setIdEmpolyee] = useState(null)
    const [idForFiles, setIdForFiles] = useState(null)
    const [employeeDB, setEmployeeDB] = useState(null)
    const [izabran, setIzabran] = useState(false)
    const [popuni, setPopuni] = useState(false)
    const [activeIndex, setActiveIndex] = useState(0)
    const [prijavaOptions, setPrijavaOptions] = useState([])
    const [prijavaOptionsMGSI, setPrijavaMGSIOptions] = useState([])
    const [radniOdnosOptions, setRadniOdnosOptions] = useState([])
    const [drzavljanstvoOptions, setDrzavljanstvoOptions] = useState([])
    const [pozicijaOptions, setPozicijaOptions] = useState([])
    const [strucnaSpremaOptions, setStrucnaSpremaOptions] = useState([])
    const [radiZaFirmeOptions, setRadiZaFirmeOptions] = useState([])   // "Radi za firme" opcije (company-in-company)
    const [trenutnaFirma, setTrenutnaFirma] = useState(null)           // firma iz tokena — uvek uključena, readonly
    const [porukaTimeRange, setPorukeTimeRange] = useState(null)
    const [typeJMBG, setTypeJMBG] = useState('number') ///za transfer JMBG tipa ukoliko je stranac u pitanju
    const [formSubmitted, setFormSubmitted] = useState(false);
    const classDocumentDB = 'btnHasDocument';
    const [buttonDocumentDB, setButtonDocumentDB] = useState({
        uploadedFileLK: 0,      
        uploadedFileVD: 0,      
        uploadedFileT: 0,       
        uploadedFileO: 0,       
        uploadedFileHealth: 0,  
        uploadedFileADR: 0,     
        uploadedFileDEF: 0,     
        uploadedFilePASS: 0,    
        uploadedFileVIZA: 0,     
        uploadedFileCPC: 0,     
        uploadedFileCPCP1: 0,   
        uploadedFileCPCP2: 0,   
        uploadedFileCPCP3: 0,   
        uploadedFileCPCP4: 0,   
        uploadedFileCPCP5: 0,    
        foreignUploadedFileLK: 0,  
        foreignUploadedFileVD: 0,      
        foreignUploadedFilePASS: 0, 
        foreignUploadedFileVIZA: 0, 
        uploadedFileContract: 0
    })

    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };
  

///DATA
    const [formDataPersonal, setFormDataPersonal] = useState({
        // Personal Data
        lastName: '',
        firstName: '',
        citizenship: null, // Dropdown should use empty string as default
        foreignCitizenship: '',
        jmbg: '',
        birthDate: null, // Calendar can typically handle null
        residencePlace: '',
        residenceAddress: '',
        birthPlace: '',
        fatherName: '',
        motherName: '',
        spouseName: '',
        children: '',
        account: '',
        foreignAccount: '',
        email: '',
        mobileNumber: '',
        workNumber: '',
        fixNumber: '',
        fixNumber2: '',
        familyContact: '',
        statusCompany: '', // Dropdown should use empty string
        statusMGSI: ''    // Dropdown should use empty string
    });
    const [formDataDocuments, setFormDataDocuments] = useState({
        // Documents
        idCardNumber: '',          // InputText (number)
        idCardExpiry: null,        // Calendar
        idSup: '',                 // InputText
        drivingLicenseNumber: '',  // InputText
        drivingLicenseExpiry: null,// Calendar
        idSupVD: '',               // InputText
        drivingLicenseCategories: [], // Checkbox group
        tachoNumber: '',           // InputText
        tachoExpiry: null,         // Calendar
        insuranceNumber: '',       // InputText (number)
        insuranceStart: null,      // Calendar
        insuranceEnd: null,        // Calendar
        healthNumber: '',          // InputText
        healthExpiry: null,        // Calendar
        adrNumber: '',             // InputText
        adrExpiry: null,           // Calendar
        adrClasses: [],            // Checkbox group
        defExpiry: null,           // Calendar
        passportNumber: '',        // InputText (number)
        passportExpiry: null,      // Calendar
        idSupPass: '',             // InputText
        visaNumber: '',            // InputText
        visaExpiry: null,          // Calendar     
    });
    const [formDataCPC, setFormDataCPC] = useState({
        //CPC
        cpcNumber: '',             // InputText
        cpcExpiry: null,           // Calendar
        cpcExpiryP1: null,         // Calendar 
        cpcExpiryP2: null,         // Calendar 
        cpcExpiryP3: null,         // Calendar  
        cpcExpiryP4: null,         // Calendar    
        cpcExpiryP5: null,         // Calendar
    });
    const [formDataForeign, setFormDataForeign] = useState({
        // Foreign Documents
        foreignIdCardNumber: '',      // InputText (number)
        foreignIdCardExpiry: null,    // Calendar
        foreignIdSup: '',             // InputText
        foreignDrivingLicenseNumber: '',  // InputText (number)
        foreignDrivingLicenseExpiry: null, // Calendar
        foreignIdSupVD: '',               // InputText
        foreignDrivingLicenseCategories: [], // Checkbox group
        foreignPassportNumber: '',     // InputText
        foreignPassportExpiry: null,   // Calendar
        foreignIdSupPass: '',          // InputText
        foreignVisaNumber: '',         // InputText
        foreignVisaExpiry: null,      // Calendar
    });
    const [formDataEmployment, setFormDataEmployment] = useState({
        // Employment Data
        contractType: null,          // Dropdown (radniOdnosDB)
        employmentStart: null,     // Calendar
        employmentEnd: null,       // Calendar (conditional)
        education: null,             // Dropdown (strucnaSpremaDB)
        position: null,              // Dropdown (pozicijaDB)
        additionalPosition: null,    // Dropdown (pozicijaDB)
        establishmentDate: null,   // Calendar
        terminationDate: null,     // Calendar
        terminationReason: '',     // InputText
        notes: '',                  // InputText,
        contractNumber: null,
        contractDate: null,
        companies: []              // "Radi za firme" — trenutna firma je uvek uključena

    });
///FILES
    const [formDataDocumentsFILES, setFormDataDocumentsFILES] = useState({
        uploadedFileLK: null,      // FileUpload
        uploadedFileVD: null,      // FileUpload
        uploadedFileT: null,       // FileUpload
        uploadedFileO: null,       // FileUpload
        uploadedFileHealth: null,  // FileUpload
        uploadedFileADR: null,     // FileUpload
        uploadedFileDEF: null,     // FileUpload
        uploadedFilePASS: null,    // FileUpload
        uploadedFileVIZA: null     // FileUpload
    });
     const [formDataCPCFILES, setFormDataCPCFILES] = useState({
        //CPC
        uploadedFileCPC: null,     // FileUpload
        uploadedFileCPCP1: null,   // FileUpload
        uploadedFileCPCP2: null,   // FileUpload
        uploadedFileCPCP3: null,   // FileUpload
        uploadedFileCPCP4: null,   // FileUpload
        uploadedFileCPCP5: null    // FileUpload
    });
    const [formDataForeignFILES, setFormDataForeignFILES] = useState({
        // Foreign Documents
        foreignUploadedFileLK: null,  // FileUpload
        foreignUploadedFileVD: null,      // FileUpload
        foreignUploadedFilePASS: null, // FileUpload
        foreignUploadedFileVIZA: null // FileUpload
    });
    const [formDataEmploymentFILES, setFormDataEmploymentFILES] = useState({
        uploadedFileContract: null
    });
  

    useEffect(()=>{
        if(!formSubmitted){
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            }
                        };
                        fetch(process.env.REACT_APP_BACKEND_URL + "/employees", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);
                                setEmployeeDB(parsedData.EmployeesDB)
                                setPrijavaOptions(parsedData.TipoviPrijaveFirma)
                                setPrijavaMGSIOptions(parsedData.TipoviPrijaveMGSI)
                                setRadniOdnosOptions(parsedData.TipoviRadnogOdnosa)
                                setDrzavljanstvoOptions(parsedData.TipoviDrzavljanstva)
                                setPozicijaOptions(parsedData.TipoviPozicije)
                                setStrucnaSpremaOptions(parsedData.TipoviStrucnaSprema)
                                setRadiZaFirmeOptions(parsedData.RadiZaFirmeDB || [])
                                const tf = parsedData.TrenutnaFirma ?? (company?.companyId ?? null)
                                setTrenutnaFirma(tf)
                                // default za NOV unos: trenutna firma čekirana (edit puni populate)
                                setFormDataEmployment(prev => ({ ...prev, companies: (prev.companies && prev.companies.length) ? prev.companies : (tf != null ? [tf] : []) }))
                                selectEmployeeFromDispatch()
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
    },[formSubmitted])

      const selectEmployeeFromDispatch = () => {
          
            if(employee !=null){
                setIdEmpolyee(employee)
                popuniRedove()
                setIzabran(true)
            } else {
                 setIzabran(false)
            }
        }
    
       useEffect(()=>{
            if(employee == null){
            resetData()
            }
       },[employee])

    const handleChangeDocUpload = (name, file) => {
        if (name in formDataDocumentsFILES) {
        setFormDataDocumentsFILES(prev => ({ ...prev, [name]: file }));
        } else if (name in formDataCPCFILES) {
        setFormDataCPCFILES(prev => ({ ...prev, [name]: file }));
        } else if (name in formDataForeignFILES) {
        setFormDataForeignFILES(prev => ({ ...prev, [name]: file }));
        } else if (name in formDataEmploymentFILES) {
        setFormDataEmploymentFILES(prev => ({ ...prev, [name]: file }));
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        
            if (name === 'citizenship') {
            setTypeJMBG(value === 31 ? 'number' : 'text');
            setFormDataPersonal(prev => ({ ...prev, jmbg: '' }));
            setFormDataPersonal(prev => ({ ...prev, [name]: value }));
            return;
            }

            if (name === 'jmbg') {
            if (formDataPersonal.citizenship == 31 && value.length <= 13) {
                setFormDataPersonal(prev => ({ ...prev, jmbg: value }));
            } else if (formDataPersonal.citizenship == 32) {
                setFormDataPersonal(prev => ({ ...prev, jmbg: value }));
            }
            return;
            }
            if (name === 'contractType' && formDataEmployment.contractType == 38) {
            setFormDataEmployment(prev => ({ ...prev, employmentEnd: null }));
            }
            if(name === 'employmentEnd' && formDataEmployment.contractType == 37 && (formDataEmployment.employmentStart >= value)) {
                setFormDataEmployment(prev => ({ ...prev, employmentEnd: null }));
                setPorukeTimeRange('Datum OD ne može biti veći od datuma DO!')
                return
            } else {
                if(porukaTimeRange != null)
                    setPorukeTimeRange(null)
            }

        if (name in formDataPersonal) {
        setFormDataPersonal(prev => ({ ...prev, [name]: value }));
        } else if (name in formDataDocuments) {
        setFormDataDocuments(prev => ({ ...prev, [name]: value }));
        } else if (name in formDataCPC) {
        setFormDataCPC(prev => ({ ...prev, [name]: value }));
        } else if (name in formDataForeign) {
        setFormDataForeign(prev => ({ ...prev, [name]: value }));
        } else if (name in formDataEmployment) {
        setFormDataEmployment(prev => ({ ...prev, [name]: value }));
        }
    };

    // "Radi za firme": trenutna firma je uvek uključena i NE može da se ukloni (readonly, uvek čekirano)
    const handleCompaniesChange = (e) => {
        const cur = trenutnaFirma ?? company?.companyId ?? null;
        let vals = Array.isArray(e.value) ? e.value.filter(v => v != null) : [];
        if (cur != null && !vals.includes(cur)) vals = [cur, ...vals];
        setFormDataEmployment(prev => ({ ...prev, companies: vals }));
    };


    const handleCheckboxChange = (e) => {
        let selectedCategories = [...formDataDocuments.drivingLicenseCategories];
        if (e.checked)
            selectedCategories.push(e.value);
        else
            selectedCategories = selectedCategories.filter(category => category !== e.value);

        setFormDataDocuments(prev => ({ ...prev, drivingLicenseCategories: selectedCategories }));
    };
    const handleCheckboxChangeADR = (e) => {
        let selectedCategories = [...formDataDocuments.adrClasses];
        if (e.checked)
            selectedCategories.push(e.value);
        else
            selectedCategories = selectedCategories.filter(category => category !== e.value);

        setFormDataDocuments(prev => ({ ...prev, adrClasses: selectedCategories }));
    };
    const handleCheckboxChangeForeign = (e) => {
        let selectedCategories = [...formDataForeign.foreignDrivingLicenseCategories];
        if (e.checked)
            selectedCategories.push(e.value);
        else
            selectedCategories = selectedCategories.filter(category => category !== e.value);

        setFormDataForeign(prev => ({ ...prev, foreignDrivingLicenseCategories: selectedCategories }));
    };
    

    const categories = [
        {name: 'A', code: 'A'},
        {name: 'B', code: 'B'},
        {name: 'C', code: 'C'},
        {name: 'D', code: 'D'},
        {name: 'E', code: 'E'},
    ];

    const adrClasses = [
        {name: '1', code: '1'},
        {name: '2', code: '2'},
        {name: '3', code: '3'},
        {name: '4', code: '4'},
        {name: '5', code: '5'},
        {name: '6', code: '6'},
        {name: '7', code: '7'},
        {name: '8', code: '8'},
        {name: '9', code: '9'},
    ];
   
    const popuniStavke = (apiData) => {

        setButtonDocumentDB({
        uploadedFileLK:  apiData[0].uploadedFileLK || 0,      
        uploadedFileVD: apiData[0].uploadedFileVD || 0,      
        uploadedFileT: apiData[0].uploadedFileT || 0,       
        uploadedFileO: apiData[0].uploadedFileO || 0,      
        uploadedFileHealth: apiData[0].uploadedFileHealth || 0, 
        uploadedFileADR: apiData[0].uploadedFileADR || 0,    
        uploadedFileDEF: apiData[0].uploadedFileDEF || 0,    
        uploadedFilePASS: apiData[0].uploadedFilePASS || 0,    
        uploadedFileVIZA: apiData[0].uploadedFileVIZA || 0, 
        uploadedFileCPC: apiData[0].uploadedFileCPC || 0,    
        uploadedFileCPCP1: apiData[0].uploadedFileCPCP1 || 0, 
        uploadedFileCPCP2: apiData[0].uploadedFileCPCP2 || 0,   
        uploadedFileCPCP3: apiData[0].uploadedFileCPCP3 || 0,   
        uploadedFileCPCP4: apiData[0].uploadedFileCPCP4 || 0,   
        uploadedFileCPCP5: apiData[0].uploadedFileCPCP5 || 0,    
        foreignUploadedFileLK: apiData[0].foreignUploadedFileLK || 0,  
        foreignUploadedFileVD: apiData[0].foreignUploadedFileVD || 0,      
        foreignUploadedFilePASS: apiData[0].foreignUploadedFilePASS || 0, 
        foreignUploadedFileVIZA: apiData[0].foreignUploadedFileVIZA || 0,
        uploadedFileContract: apiData[0].uploadedFileContract || 0
        })
     
    setFormDataPersonal({
        lastName: apiData[0].LastName || '',
        firstName: apiData[0].FirstName || '',
        citizenship: parseInt(apiData[0].Citizenship) || null,
        foreignCitizenship: apiData[0].ForeignCitizenship || '',
        jmbg: apiData[0].JMBG || '',
        birthDate: apiData[0].BirthDate ? new Date(apiData[0].BirthDate) : null,
        residencePlace: apiData[0].ResidencePlace || '',
        residenceAddress: apiData[0].ResidenceAddress || '',
        birthPlace: apiData[0].BirthPlace || '',
        fatherName: apiData[0].FatherName || '',
        motherName: apiData[0].MotherName || '',
        spouseName: apiData[0].SpouseName || '',
        children: apiData[0].Children || '',
        account: apiData[0].Account || '',
        foreignAccount: apiData[0].ForeignAccount || '',
        email: apiData[0].Email || '',
        mobileNumber: apiData[0].MobileNumber || '',
        workNumber: apiData[0].WorkNumber || '',
        fixNumber: apiData[0].FixNumber || '',
        fixNumber2: apiData[0].FixNumber2 || '',
        familyContact: apiData[0].FamilyContact || '',
        statusCompany: parseInt(apiData[0].StatusCompany?.toString()) || '',
        statusMGSI: parseInt(apiData[0].StatusMGSI?.toString()) || ''
    });

    // Documents
    setFormDataDocuments({
        idCardNumber: apiData[0].idCardNumber || '',
        idCardExpiry: apiData[0].idCardExpiry ? new Date(apiData[0].idCardExpiry) : null,
        idSup: apiData[0].idSup || '',
        drivingLicenseNumber: apiData[0].drivingLicenseNumber || '',
        drivingLicenseExpiry: apiData[0].drivingLicenseExpiry ? new Date(apiData[0].drivingLicenseExpiry) : null,
        idSupVD: apiData[0].idSupVD || '',
        drivingLicenseCategories: apiData[0].drivingLicenseCategories ? 
            apiData[0].drivingLicenseCategories.split(',') : [],
        tachoNumber: apiData[0].tachoNumber || '',
        tachoExpiry: apiData[0].tachoExpiry ? new Date(apiData[0].tachoExpiry) : null,
        insuranceNumber: apiData[0].insuranceNumber || '',
        insuranceStart: apiData[0].insuranceStart ? new Date(apiData[0].insuranceStart) : null,
        insuranceEnd: apiData[0].insuranceEnd ? new Date(apiData[0].insuranceEnd) : null,
        healthNumber: apiData[0].healthNumber || '',
        healthExpiry: apiData[0].healthExpiry ? new Date(apiData[0].healthExpiry) : null,
        adrNumber: apiData[0].adrNumber || '',
        adrExpiry: apiData[0].adrExpiry ? new Date(apiData[0].adrExpiry) : null,
        adrClasses: apiData[0].adrClasses ? apiData[0].adrClasses.split(',') : [],
        defExpiry: apiData[0].defExpiry ? new Date(apiData[0].defExpiry) : null,
        passportNumber: apiData[0].passportNumber || '',
        passportExpiry: apiData[0].passportExpiry ? new Date(apiData[0].passportExpiry) : null,
        idSupPass: apiData[0].idSupPass || '',
        visaNumber: apiData[0].visaNumber || '',
        visaExpiry: apiData[0].visaExpiry ? new Date(apiData[0].visaExpiry) : null
    });

    // CPC
    setFormDataCPC({
        cpcNumber: apiData[0].cpcNumber || '',
        cpcExpiry: apiData[0].cpcExpiry ? new Date(apiData[0].cpcExpiry) : null,
        cpcExpiryP1: apiData[0].cpcExpiryP1 ? new Date(apiData[0].cpcExpiryP1) : null,
        cpcExpiryP2: apiData[0].cpcExpiryP2 ? new Date(apiData[0].cpcExpiryP2) : null,
        cpcExpiryP3: apiData[0].cpcExpiryP3 ? new Date(apiData[0].cpcExpiryP3) : null,
        cpcExpiryP4: apiData[0].cpcExpiryP4 ? new Date(apiData[0].cpcExpiryP4) : null,
        cpcExpiryP5: apiData[0].cpcExpiryP5 ? new Date(apiData[0].cpcExpiryP5) : null
    });

    // Foreign Documents
    setFormDataForeign({
        foreignIdCardNumber: apiData[0].foreignIdCardNumber || '',
        foreignIdCardExpiry: apiData[0].foreignIdCardExpiry ? new Date(apiData[0].foreignIdCardExpiry) : null,
        foreignIdSup: apiData[0].foreignIdSup || '',
        foreignDrivingLicenseNumber: apiData[0].foreignDrivingLicenseNumber || '',
        foreignDrivingLicenseExpiry: apiData[0].foreignDrivingLicenseExpiry ? new Date(apiData[0].foreignDrivingLicenseExpiry) : null,
        foreignIdSupVD: apiData[0].foreignIdSupVD || '',
        foreignDrivingLicenseCategories: apiData[0].foreignDrivingLicenseCategories ? 
            apiData[0].foreignDrivingLicenseCategories.split(',') : [],
        foreignPassportNumber: apiData[0].foreignPassportNumber || '',
        foreignPassportExpiry: apiData[0].foreignPassportExpiry ? new Date(apiData[0].foreignPassportExpiry) : null,
        foreignIdSupPass: apiData[0].foreignIdSupPass || '',
        foreignVisaNumber: apiData[0].foreignVisaNumber || '',
        foreignVisaExpiry: apiData[0].foreignVisaExpiry ? new Date(apiData[0].foreignVisaExpiry) : null
    });

    // Employment Data
    setFormDataEmployment({
        contractType: parseInt(apiData[0].contractType) || null,
        employmentStart: apiData[0].employmentStart ? new Date(apiData[0].employmentStart) : null,
        employmentEnd: apiData[0].employmentEnd ? new Date(apiData[0].employmentEnd) : null,
        education: parseInt(apiData[0].education) || null,
        position: parseInt(apiData[0].position) || null,
        additionalPosition: parseInt(apiData[0].additionalPosition) || null,
        establishmentDate: apiData[0].establishmentDate ? new Date(apiData[0].establishmentDate) : null,
        terminationDate: apiData[0].terminationDate ? new Date(apiData[0].terminationDate) : null,
        terminationReason: apiData[0].terminationReason || '',
        notes: apiData[0].notes || '',
        contractNumber: parseInt(apiData[0].contractNumber) || null,
        contractDate: apiData[0].contractDate ? new Date(apiData[0].contractDate) : null,
        // "Radi za firme": Companies je comma-separated string firma_id-jeva iz junction tabele
        companies: apiData[0].Companies
            ? String(apiData[0].Companies).split(',').map(x => parseInt(x, 10)).filter(Number.isInteger)
            : (trenutnaFirma != null ? [trenutnaFirma] : []),
    });
};

    /* prima izbor iz dropdowna; bez argumenta radi po redux vrednosti */
    const popuniRedove = async (izbor) => {

        const izabrani = izbor || employee;

        if(izabrani)  {
             setPopuni(true);
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: izabrani
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/employees/FillInEmployeeData", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                              if(data && data.length > 0) {
                                popuniStavke(data)
                              } else {
                                if(izabrani)
                                dispatch({type: "EMPLOYEE",value: null });
                            
                                  toast.current.show({
                                    severity: "info",
                                    summary: t('admin.m_obavestenje_1'),
                                    detail: t('admin.m_pasivan_zaposleni'),
                                    life: 3000,
                                });
                              }
                              
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        } else {
             toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_izabrali_zaposlenog_da_bi_popunili'),
                        life: 3000,
                    });
        } 
          
    }
    const handleUploadAndSaveFiles = async (id)=> {
              
                                            const formData = new FormData();
                                            formData.append("id", id);
                                            formData.append("entityType", "zaposleni");

                                            Object.entries(formDataDocumentsFILES).forEach(([key, file]) => {
                                            if (file) formData.append(key, file);
                                            });
                                            Object.entries(formDataCPCFILES).forEach(([key, file]) => {
                                            if (file) formData.append(key, file);
                                            });
                                            Object.entries(formDataForeignFILES).forEach(([key, file]) => {
                                            if (file) formData.append(key, file);
                                            });
                                            Object.entries(formDataEmploymentFILES).forEach(([key, file]) => {
                                            if (file) formData.append(key, file);
                                            });

                                            let requestOptionsFiles = {
                                                method: "POST",
                                                headers: {
                                                Authorization: "Bearer " + auth.token,
                                                },
                                                body: formData
                                            };
       
                                                await fetch(process.env.REACT_APP_BACKEND_URL + "/employees/InsertEmployeeFiles", requestOptionsFiles)
                                                .then(handleErrors)
                                                .then((data) => {
                                                    
                                                    setIdForFiles(false)
                                                    setIzabran(false)
                                                    setPopuni(false)
                                                    resetData()
                                                    resetDataFiles()
                                                    toast.current.show({
                                                    severity: "success",
                                                    summary: data.message,
                                                    life: 3000,
                                                      });

                                                })
                                                .catch((error) => {
                                                error.json().then((errorMessage) => {
                                                    toast.current.show({
                                                    severity: "error",
                                                    summary: "Error",
                                                    detail: errorMessage[0].message,
                                                    life: 3000,
                                                    });
                                                    console.log(errorMessage);
                                                });
                                            })
                                 
    }
       
const resetData = ()=> {
        setFormDataPersonal({
        lastName: '',
        firstName: '',
        citizenship: null,
        foreignCitizenship: '',
        jmbg: '',
        birthDate: null,
        residencePlace: '',
        residenceAddress: '',
        birthPlace: '',
        fatherName: '',
        motherName: '',
        spouseName: '',
        children: '',
        account: '',
        foreignAccount: '',
        email: '',
        mobileNumber: '',
        workNumber: '',
        fixNumber: '',
        fixNumber2: '',
        familyContact: '',
        statusCompany: '',
        statusMGSI: ''
    });
    setFormDataDocuments({
        idCardNumber: null,   
        idCardExpiry: null,
        idSup: null,
        drivingLicenseNumber: null, 
        drivingLicenseExpiry: null,
        idSupVD: null,
        drivingLicenseCategories: [],
        tachoNumber: null,
        tachoExpiry: null,
        insuranceNumber: null,
        insuranceStart: null,
        insuranceEnd: null,
        healthNumber: null,
        healthExpiry: null,
        adrNumber: null,
        adrExpiry: null,
        adrClasses: [],
        defExpiry: null,
        passportNumber: null, 
        passportExpiry: null, 
        idSupPass: null,
        visaNumber: null,
        visaExpiry: null,   
    });
   setFormDataCPC({
        cpcNumber: '', 
        cpcExpiry: null,
        cpcExpiryP1: null, 
        cpcExpiryP2: null,
        cpcExpiryP3: null, 
        cpcExpiryP4: null,  
        cpcExpiryP5: null, 
    });

  setFormDataForeign({
        foreignIdCardNumber: '',     
        foreignIdCardExpiry: null,   
        foreignIdSup: '',           
        foreignDrivingLicenseNumber: '', 
        foreignDrivingLicenseExpiry: null, 
        foreignIdSupVD: '',          
        foreignDrivingLicenseCategories: [],
        foreignPassportNumber: '',     
        foreignPassportExpiry: null,   
        foreignIdSupPass: '',         
        foreignVisaNumber: '',        
        foreignVisaExpiry: null,  
    });
  setFormDataEmployment({
        contractType: null,
        employmentStart: null,
        employmentEnd: null,
        education: null,
        position: null,
        additionalPosition: null,
        establishmentDate: null,
        terminationDate: null,
        terminationReason: '',
        notes: '',
        contractNumber: null,
        contractDate: null,
        companies: (trenutnaFirma != null ? [trenutnaFirma] : []),  // posle reseta trenutna firma ostaje čekirana
    });
}
const resetDataFiles=()=>{
     setFormDataDocumentsFILES({
        uploadedFileLK: null,
        uploadedFileVD: null,
        uploadedFileT: null,
        uploadedFileO: null,
        uploadedFileHealth: null,
        uploadedFileADR: null,
        uploadedFileDEF: null,
        uploadedFilePASS: null,
        uploadedFileVIZA: null
    });
    setFormDataCPCFILES({
        uploadedFileCPC: null,
        uploadedFileCPCP1: null,
        uploadedFileCPCP2: null,
        uploadedFileCPCP3: null,
        uploadedFileCPCP4: null,
        uploadedFileCPCP5: null 
    });
    setFormDataForeignFILES({
        foreignUploadedFileLK: null,
        foreignUploadedFileVD: null, 
        foreignUploadedFilePASS: null, 
        foreignUploadedFileVIZA: null 
    });
    setFormDataEmploymentFILES({
        uploadedFileContract: null
    });
}
 const handleFormSubmit = (e) => {

            e.preventDefault(); // bitno da ne submituje bez validacije
                setFormSubmitted(true)
            if (formRef.current && !formRef.current.checkValidity()) {
                formRef.current.reportValidity(); // prikazuje native browser poruke
                return;
            }
    handleUploadAndSave()
 }
        const handleUploadAndSave = () => {
       
            confirmDialog({
            message: "Jel ste sigurni da želite nastaviti sa unosom?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptInsert,
            reject: rejectInsert,
            });
            //FILES

    };


    function toUtcIso(d) {
        if (!d) return null;
        const x = d instanceof Date ? d : new Date(d);
        const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
        return utc.toISOString().slice(0, 19) + 'Z';
    }

    const acceptInsert = async () => {
            if(activeIndex != [] && (formDataPersonal.lastName == '' || formDataPersonal.firstName == '' || formDataPersonal.citizenship == null || 
                formDataPersonal.jmbg == '' || formDataPersonal.birthDate == null || formDataPersonal.residencePlace == '' || formDataPersonal.residenceAddress == ''))
                 {
                setActiveIndex([0])
                return
            }

            if(formDataEmployment.position == null || formDataEmployment.contractType == null) {
                setActiveIndex([4])
                return
            }

                   const hasAnyValueDocumentsFiles = Object.values(formDataDocumentsFILES).some(value => {
                if (value === null || value === '') return false;
                if (value instanceof Date && isNaN(value.getTime())) return false;
                return true;
                });
            const hasAnyValueCPCFiles = Object.values(formDataCPCFILES).some(value => {
                if (value === null || value === '') return false;
                if (value instanceof Date && isNaN(value.getTime())) return false;
                return true;
                });
            const hasAnyValueForeignFiles = Object.values(formDataForeignFILES).some(value => {
                if (value === null || value === '') return false;
                if (value instanceof Date && isNaN(value.getTime())) return false;
                return true;
                });

            const hasAnyValueEmployementFiles = Object.values(formDataEmploymentFILES).some(value => {
                if (value === null || value === '') return false;
                if (value instanceof Date && isNaN(value.getTime())) return false;
                return true;
                });
            //DATA
                const hasAnyValuePersonal = Object.values(formDataPersonal).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });
              const hasAnyValueDocuments = Object.values(formDataDocuments).some((value) => {
                if (value === null || value === '') return false;

                // If it's a date, ensure it's valid
                if (value instanceof Date) {
                    return !isNaN(value.getTime());
                }

                // If it's a File (or Blob), check size > 0
                if (value instanceof File || value instanceof Blob) {
                    return value.size > 0;
                }

                // Any other truthy value
                return true;
                });
                const hasAnyValueCPC = Object.values(formDataCPC).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });
            const hasAnyValueForeign = Object.values(formDataForeign).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });
            const hasAnyValueEmployment = Object.values(formDataEmployment).some(value => {
                if (value === null || value === '') return false;

                // Check if it's a valid Date object
                if (value instanceof Date && isNaN(value.getTime())) return false;

                return true;
                });

                   const payload1 = {
                        ...formDataPersonal,
                        birthDate: toUtcIso(formDataPersonal.birthDate)
                        };
 
                    const payload2 = {
                        ...formDataDocuments,
                        idCardExpiry: toUtcIso(formDataDocuments.idCardExpiry),
                        drivingLicenseExpiry: toUtcIso(formDataDocuments.drivingLicenseExpiry),
                        healthCardExpiry: toUtcIso(formDataDocuments.healthCardExpiry),
                        tachoExpiry: toUtcIso(formDataDocuments.tachoExpiry),
                        insuranceStart: toUtcIso(formDataDocuments.insuranceStart),
                        insuranceEnd: toUtcIso(formDataDocuments.insuranceEnd),
                        healthExpiry: toUtcIso(formDataDocuments.healthExpiry),
                        adrExpiry: toUtcIso(formDataDocuments.adrExpiry),
                        defExpiry: toUtcIso(formDataDocuments.defExpiry),
                        passportExpiry: toUtcIso(formDataDocuments.passportExpiry),
                        visaExpiry: toUtcIso(formDataDocuments.visaExpiry)
                        };

                     const payload3 = {
                        ...formDataCPC,
                        cpcExpiry: toUtcIso(formDataCPC.cpcExpiry),
                        cpcExpiryP1: toUtcIso(formDataCPC.cpcExpiryP1),
                        cpcExpiryP2: toUtcIso(formDataCPC.cpcExpiryP2),
                        cpcExpiryP3: toUtcIso(formDataCPC.cpcExpiryP3),
                        cpcExpiryP4: toUtcIso(formDataCPC.cpcExpiryP4),
                        cpcExpiryP5: toUtcIso(formDataCPC.cpcExpiryP5),
                        };

                     const payload4 = {
                        ...formDataForeign,
                        foreignIdCardExpiry: toUtcIso(formDataForeign.foreignIdCardExpiry),
                        foreignDrivingLicenseExpiry: toUtcIso(formDataForeign.foreignDrivingLicenseExpiry),
                        foreignPassportExpiry: toUtcIso(formDataForeign.foreignPassportExpiry),
                        foreignVisaExpiry: toUtcIso(formDataForeign.foreignVisaExpiry)
                        };
                     const payload5 = {
                        ...formDataEmployment,
                        employmentStart: toUtcIso(formDataEmployment.employmentStart),
                        employmentEnd: toUtcIso(formDataEmployment.employmentEnd),
                        establishmentDate: toUtcIso(formDataEmployment.establishmentDate),
                        terminationDate: toUtcIso(formDataEmployment.terminationDate)
                        };

            if(izabran && popuni){
                 if(hasAnyValuePersonal || hasAnyValueDocuments || hasAnyValueCPC || hasAnyValueForeign || hasAnyValueEmployment){
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: idEmployee,
                                formDataPersonal: payload1,
                                formDataDocuments: payload2,
                                formDataCPC: payload3,
                                formDataForeign: payload4,
                                formDataEmployment: payload5
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/employees/UpdateEmployee", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                               
                                if(data[0].message && data[0].message != 'Nema izmena u podacima zaposlenog.'){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data[0].message,
                                    life: 3000,
                                    });
                                    return
                                }  

                                if(data[0].message == 'Nema izmena u podacima zaposlenog.'){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                                } else {
                                toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesna_izmena_podataka_zaposlenog'),
                                life: 3000,
                                });
                                }
                                
                                 setFormSubmitted(false)
                                setIdForFiles(data.id)
                                if((idEmployee) && (hasAnyValueDocumentsFiles || hasAnyValueCPCFiles || hasAnyValueForeignFiles || hasAnyValueEmployementFiles)) {
                                handleUploadAndSaveFiles(idEmployee)
                                }
                                setIzabran(null)
                                setPopuni(null)
                                setIdEmpolyee(null)
                                resetData()
                                resetDataFiles()
                                
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_popunili_podatke_zaposlenog_za_uno'),
                        life: 3000,
                    });
                }
           
           
            } else {
                

                if(hasAnyValuePersonal || hasAnyValueDocuments || hasAnyValueCPC || hasAnyValueForeign || hasAnyValueEmployment){
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                formDataPersonal: payload1,
                                formDataDocuments: payload2,
                                formDataCPC: payload3,
                                formDataForeign: payload4,
                                formDataEmployment: payload5
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/employees/InsertEmployee", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                                setFormSubmitted(false)
                                resetData()
                                setIdForFiles(data.id)
                                setIzabran(false)
                                setPopuni(false)
                                if((data.id || idForFiles) && (hasAnyValueDocumentsFiles || hasAnyValueCPCFiles || hasAnyValueForeignFiles || hasAnyValueEmployementFiles)) {
            
                                handleUploadAndSaveFiles(data.id || idForFiles)
                                }

                                
                               toast.current.show({
                                severity: "success",
                                summary: t('admin.m_uspesan_unos_podataka_zaposlenog'),
                                life: 3000,
                                });
                              
                            //ubaciti deo da se forma ID za dalji unos
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: t('admin.m_upozorenje_2'),
                        detail: t('admin.m_niste_popunili_podatke_zaposlenog_za_uno'),
                        life: 3000,
                    });
                }
            }

  };
           

  const rejectInsert = () => {
    console.log("Odbijen unos podataka!");
  };

    const selectIdemployeeFUNC = (e) => {
        const izabrani = e.target.value;
        dispatch({ type: "EMPLOYEE", value: izabrani == undefined ? null : izabrani });

        if (izabrani == undefined) {
            setIzabran(false);
            setPopuni(false);
            resetData();
            resetDataFiles();
        } else {
            setIzabran(true);
            setIdEmpolyee(izabrani);
            popuniRedove(izabrani);   // podaci se ucitavaju odmah, bez dugmeta
        }
    };
const invalidControl = (data) => {
  if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata

  if (data && data != null && !Number(data)) {
    return data.length > 0 ? false : true;
  } else if (data != null && Number(data)) {
    return false;
  }
  return true;
};
const changeDateFromJMBG = () => {
    
    if(formDataPersonal.citizenship ==31 && formDataPersonal.jmbg.length == 13){
                const jmbg = formDataPersonal.jmbg
            const dan = parseInt(jmbg.slice(0, 2), 10);
        const mesec = parseInt(jmbg.slice(2, 4), 10);
        const godinaRaw = parseInt(jmbg.slice(4, 7), 10);

        // Logika za godinu
        let godina;
        if (godinaRaw >= 900) {
            godina = 1000 + godinaRaw; // npr. 991 → 1991
        } else {
            godina = 2000 + godinaRaw; // npr. 002 → 2002
        }

        // Kreiranje datuma
        const datum = new Date(godina, mesec - 1, dan);
        setFormDataPersonal(prev => ({ ...prev, birthDate: datum }));
    }
    
}

    const resetDispatchEmployee = () => {
          dispatch({
                            type: "EMPLOYEE",
                            value: null
                        });
    }

  const handleSelect = () => {
    if (idEmployee) {  // resetuj samo ako ima vrednost
        setIdEmpolyee(null)
        setIzabran(false)
        setPopuni(false)
        resetDispatchEmployee()
        resetData()
        resetDataFiles()
    }
   
  }

  const handlePrintContract = () => {
      if(employee) {
        let requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
        body: JSON.stringify({
          id: employee
        }),
      };
      
      fetch(process.env.REACT_APP_BACKEND_URL + "/employees/PrintContract", requestOptions)
        .then(handleErrors)
        .then((data) => {
            if(data.message) {
               toast.current.show({
                                  severity: "warn",
                                  summary: data.message,
                                  life: 3000,
                                  });
              return
             }
          if(data){
            handlePrint(data)
          } 
  
        })
        .catch((error) => {
          error.json().then((errorMessage) => {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: errorMessage.message,
              life: 3000,
            });
            console.log(errorMessage);
          });
        });
      } else {
         toast.current.show({
              severity: "warn",
              summary: t('admin.m_upozorenje_2'),
              detail: t('admin.m_niste_izabrali_zaposlenog_da_bi_stampali'),
              life: 3000,
            });
      }
  }

    return (
        <div className="p-fluid grid formUnosZap">
            <div className="col-12">
                <Divider />
                  <div className="gridHeader">
                            <h4>{t('finansije.izborZaposlenog')}:</h4>
                                       <CustomDropdown
                                                                 style={{ width: "20%", marginLeft: '1%' }}
                                                                 id="id_employee" 
                                                                 name="id_employee" 
                                                                 value={idEmployee} 
                                                                 required
                                                                 options={employeeDB || []}
                                                                 placeholder={t('finansije.izaberiZaposlenog')}
                                                                 optionLabel="label"
                                                                 onChange={selectIdemployeeFUNC}
                                                                 onFocus={handleSelect}
                                                             />
                </div>
            </div>
            <Toast ref={toast} />
            <ConfirmDialog />
            <form autoComplete="off" ref={formRef}>
            <Accordion className='zaposleniDashboard' multiple  activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.licniPodaci')}>
                        <div className="col-12 md:col-6">
                <Card>
                    <div className="gridLicni">
                        <div className="col-12 md:col-6">
                            <label htmlFor="lastName">{t('login.prezime')}:</label>
                            <InputText required invalid={invalidControl(formDataPersonal.lastName)} id="lastName" name="lastName" value={formDataPersonal.lastName} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="firstName">{t('login.ime')}:</label>
                            <InputText required invalid={invalidControl(formDataPersonal.firstName)} id="firstName" name="firstName" value={formDataPersonal.firstName} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="citizenship">{t('admin.drzavljanstvo')}:</label>
                            <Dropdown required invalid={invalidControl(formDataPersonal.citizenship)} placeholder={t('admin.phDrzavljanstvo')} id="citizenship" name="citizenship" value={formDataPersonal.citizenship} 
                                options={drzavljanstvoOptions} onChange={handleChange}/>
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="foreignCitizenship">{t('admin.inostrano')}:</label>
                            <InputText disabled={formDataPersonal.citizenship == 31 ? true : false } id="foreignCitizenship" name="foreignCitizenship" value={formDataPersonal.foreignCitizenship} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="jmbg">{t('admin.jmbg')}:</label>
                            <InputText required invalid={invalidControl(formDataPersonal.jmbg)} id="jmbg" name="jmbg" type={typeJMBG} value={formDataPersonal.jmbg} onBlur={changeDateFromJMBG} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="birthDate">{t('admin.datumRodjenja')}:</label>
                            <Calendar id="birthDate" name="birthDate" value={formDataPersonal.birthDate} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="residencePlace">{t('admin.mestoPrebivalista')}:</label>
                            <InputText required invalid={invalidControl(formDataPersonal.residencePlace)} id="residencePlace" name="residencePlace" value={formDataPersonal.residencePlace} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="residenceAddress">{t('admin.adresaPrebivalista')}:</label>
                            <InputText required invalid={invalidControl(formDataPersonal.residenceAddress)} id="residenceAddress" name="residenceAddress" value={formDataPersonal.residenceAddress} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="birthPlace">{t('admin.mestoRodjenja')}:</label>
                            <InputText id="birthPlace" name="birthPlace" value={formDataPersonal.birthPlace} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="fatherName">{t('admin.imeOca')}:</label>
                            <InputText id="fatherName" name="fatherName" value={formDataPersonal.fatherName} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="motherName">{t('admin.imeMajke')}:</label>
                            <InputText id="motherName" name="motherName" value={formDataPersonal.motherName} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="spouseName">{t('admin.imeSupruge')}:</label>
                            <InputText id="spouseName" name="spouseName" value={formDataPersonal.spouseName} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="children">{t('admin.deca')}:</label>
                            <InputText id="children" name="children" value={formDataPersonal.children} onChange={handleChange} />
                        </div>
                         <div className="col-12 md:col-6">
                            <label htmlFor="account">{t('nova.tekuciRacun')}:</label>
                            <InputText id="account" name="account" value={formDataPersonal.account} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="foreignAccount">{t('admin.devizniRacun')}:</label>
                            <InputText id="foreignAccount" name="foreignAccount" value={formDataPersonal.foreignAccount} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="email">{t('login.email')}:</label>
                        <InputText id="email"  name="email" keyfilter={/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g} validateOnly value={formDataPersonal.email} onChange={handleChange}/>
                        </div>
                         <div className="col-12 md:col-6">
                            <label htmlFor="mobileNumber">{t('admin.mobilniBroj')}:</label>
                            <InputText id="mobileNumber" name="mobileNumber" value={formDataPersonal.mobileNumber} onChange={handleChange} />
                        </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="workNumber">{t('admin.sluzbeniBroj')}:</label>
                            <InputText id="workNumber" name="workNumber" value={formDataPersonal.workNumber} onChange={handleChange} />
                        </div>
                         <div className="col-12 md:col-6">
                            <label htmlFor="fixNumber">{t('admin.fiksniBroj')}:</label>
                            <InputText id="fixNumber" name="fixNumber" value={formDataPersonal.fixNumber} onChange={handleChange} />
                        </div>
                         <div className="col-12 md:col-6">
                            <label htmlFor="fixNumber2">{t('admin.fiksniBroj2')}:</label>
                            <InputText id="fixNumber2" name="fixNumber2" value={formDataPersonal.fixNumber2} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="familyContact">{t('admin.kontaktPorodice')}:</label>
                            <InputText id="familyContact" name="familyContact" value={formDataPersonal.familyContact} onChange={handleChange} />
                        </div>
                         <div className="col-12 md:col-6">
                            <label htmlFor="statusCompany">{t('admin.statusFirmi')}:</label>
                            <Dropdown placeholder={t('nova.phStatus')} id="statusCompany" name="statusCompany" value={formDataPersonal.statusCompany} 
                                options={prijavaOptions} onChange={handleChange} />
                        </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="statusMGSI">{t('admin.statusMinistarstvo')}:</label>
                            <Dropdown placeholder={t('admin.phUMgsi')} id="statusMGSI" name="statusMGSI" value={formDataPersonal.statusMGSI} 
                                options={prijavaOptionsMGSI} onChange={handleChange} />
                        </div>
                    </div>
                </Card>
            </div>
                </AccordionTab>
                <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.dokumenta')}>
                  <div className="col-12 md:col-6">
                <Card>
                    <div className="gridDokumenti">
                        <div className="red1 redDokument"> 
                            <div className="col-12">
                                <h4>Lična karta:</h4>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="idCardNumber">{t('nova.broj')}:</label>
                                <InputText id="idCardNumber" name="idCardNumber" type="number" value={formDataDocuments.idCardNumber} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="idCardExpiry">{t('admin.datumVazenja')}:</label>
                                <Calendar id="idCardExpiry" name="idCardExpiry" value={formDataDocuments.idCardExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="idSup">{t('admin.sup')}:</label>
                                <InputText id="idSup" name="idSup" value={formDataDocuments.idSup} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                            <label htmlFor="docLK">{t('nova.dokument')}:</label>
                        {!formDataDocumentsFILES.uploadedFileLK ? <FileUpload
                                name="uploadedFileLK"
                                className={buttonDocumentDB.uploadedFileLK && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileLK ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileLK", e.files[0])}
                                />: <Button label={formDataDocumentsFILES.uploadedFileLK.name} onClick={() => handleChangeDocUpload("uploadedFileLK", null)} />}
                            </div>
                        </div>
                       <div className="red2 redDokument"> 
                            <div className="col-12">
                                <h4>Vozačka dozvola:</h4>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="drivingLicenseNumber">{t('nova.broj')}:</label>
                                <InputText id="drivingLicenseNumber" name="drivingLicenseNumber" value={formDataDocuments.drivingLicenseNumber} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="drivingLicenseExpiry">{t('admin.datumVazenja')}:</label>
                                <Calendar id="drivingLicenseExpiry" name="drivingLicenseExpiry" value={formDataDocuments.drivingLicenseExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999" />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="idSupVD">{t('admin.sup')}:</label>
                                <InputText id="idSupVD" name="idSupVD" value={formDataDocuments.idSupVD} onChange={handleChange} />
                            </div>
                            
                            <div className="col-12 flexColumn">
                                <label>{t('admin.kategorije')}:</label>
                                <div className="flex flex-wrap gap-3">
                                    {categories.map((category) => (
                                        <div key={category.code} className="flex align-items-center">
                                            <label htmlFor={category.code} className="ml-2">{category.name}:</label>
                                            <Checkbox inputId={category.code} name="drivingLicenseCategories" 
                                                value={category.code} onChange={handleCheckboxChange} 
                                                checked={formDataDocuments.drivingLicenseCategories.includes(category.code)} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                                <div className="col-12 md:col-6">
                                <label htmlFor="docVD">{t('nova.dokument')}:</label>
                                {!formDataDocumentsFILES.uploadedFileVD ? <FileUpload
                                name="uploadedFileVD"
                                className={buttonDocumentDB.uploadedFileVD && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileVD ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileVD", e.files[0])}
                                />: <Button label={formDataDocumentsFILES.uploadedFileVD.name} onClick={() => handleChangeDocUpload("uploadedFileVD", null)} />}
                                    </div>
                                    
                        </div>
                        
                       <div className="red3 redDokument">
                            <div className="col-12">
                                <h4>TAHO KARTICA:</h4>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="tachoNumber">{t('nova.broj')}:</label>
                                <InputText id="tachoNumber" name="tachoNumber" value={formDataDocuments.tachoNumber} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="tachoExpiry">{t('admin.datumVazenja')}:</label>
                                <Calendar id="tachoExpiry" name="tachoExpiry" value={formDataDocuments.tachoExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="docVD">{t('nova.dokument')}:</label>
                                 {!formDataDocumentsFILES.uploadedFileT ? <FileUpload
                                name="uploadedFileT"
                                className={buttonDocumentDB.uploadedFileT && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileT ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileT", e.files[0])}
                                />: <Button label={formDataDocumentsFILES.uploadedFileT.name} onClick={() => handleChangeDocUpload("uploadedFileT", null)} />}
                                    </div>  
                       </div>
                        <div className="red4 redDokument">
                            <div className="col-12">
                                <h4>PUTNO Z. OSIGURANJE:</h4>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="insuranceNumber">{t('nova.broj')}:</label>
                                <InputText id="insuranceNumber" name="insuranceNumber" type="number" value={formDataDocuments.insuranceNumber} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="insuranceStart">{t('admin.datumZasnivanja')}:</label>
                                <Calendar id="insuranceStart" name="insuranceStart" value={formDataDocuments.insuranceStart} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="insuranceEnd">{t('admin.datumVazenja')}:</label>
                                <Calendar id="insuranceEnd" name="insuranceEnd" value={formDataDocuments.insuranceEnd} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="docVD">{t('nova.dokument')}:</label>
                                           {!formDataDocumentsFILES.uploadedFileO ? <FileUpload
                                name="uploadedFileO"
                                className={buttonDocumentDB.uploadedFileO && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileO ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileO", e.files[0])}
                                />: <Button label={formDataDocumentsFILES.uploadedFileO.name} onClick={() => handleChangeDocUpload("uploadedFileO", null)} />}
                                    </div>
                        </div>
                        <div className="red5 redDokument">
                            <div className="col-12">
                            <h4>LEKARSKO:</h4>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="healthNumber">{t('nova.broj')}:</label>
                                <InputText id="healthNumber" name="healthNumber" value={formDataDocuments.healthNumber} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="healthExpiry">{t('admin.datumVazenja')}:</label>
                                <Calendar id="healthExpiry" name="healthExpiry" value={formDataDocuments.healthExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                            <label htmlFor="docLK">{t('nova.dokument')}:</label>
                                {!formDataDocumentsFILES.uploadedFileHealth ? <FileUpload
                                name="uploadedFileHealth"
                                className={buttonDocumentDB.uploadedFileHealth && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileHealth ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileHealth", e.files[0])}
                                />: <Button label={formDataDocumentsFILES.uploadedFileHealth.name} onClick={() => handleChangeDocUpload("uploadedFileHealth", null)} />}
                            </div>         
                        </div>
                        <div className="red6 redDokument">
                             <div className="col-12">
                            <h4>ADR:</h4>
                            </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="adrNumber">{t('nova.broj')}:</label>
                            <InputText id="adrNumber" name="adrNumber" value={formDataDocuments.adrNumber} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="adrExpiry">{t('admin.datumVazenja')}:</label>
                            <Calendar id="adrExpiry" name="adrExpiry" value={formDataDocuments.adrExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                        </div>
                        <div className="col-12 flexColumnADR">
                            <label>{t('admin.klase')}:</label>
                            <div className="flex flex-wrap gap-3">
                                {adrClasses.map((cls) => (
                                    <div key={cls.code} className="flex align-items-center">
                                         <label htmlFor={`adr-${cls.code}`} className="ml-2">{cls.name}:</label>
                                         <Checkbox inputId={cls.code} name="adrClasses" 
                                                value={cls.code} onChange={handleCheckboxChangeADR} 
                                                checked={formDataDocuments.adrClasses.includes(cls.code)} />
                                    </div>
                                ))}
                            </div>
                        </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="docLK">{t('nova.dokument')}:</label>
                          {!formDataDocumentsFILES.uploadedFileADR ? <FileUpload
                                name="uploadedFileADR"
                                className={buttonDocumentDB.uploadedFileADR && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileADR ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileADR", e.files[0])}
                                />: <Button label={formDataDocumentsFILES.uploadedFileADR.name} onClick={() => handleChangeDocUpload("uploadedFileADR", null)} />}
                            </div>
                        </div>
                       <div className="red7 redDokument">
                             <div className="col-12">
                            <h4>Bezbednost na radu:</h4>
                            </div>
                    
                         <div className="col-12 md:col-6">
                            <label htmlFor="defExpiry">{t('admin.datumVazenja')}:</label>
                            <Calendar id="defExpiry" name="defExpiry" value={formDataDocuments.defExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999" />
                        </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="docLK">{t('nova.dokument')}:</label>
                            {!formDataDocumentsFILES.uploadedFileDEF ? <FileUpload
                                name="uploadedFileDEF"
                                className={buttonDocumentDB.uploadedFileDEF && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileDEF ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileDEF", e.files[0])}
                                />: <Button label={formDataDocumentsFILES.uploadedFileDEF.name} onClick={() => handleChangeDocUpload("uploadedFileDEF", null)} />}
                        </div>
                    </div>
                    <div className="red8 redDokument">
                             <div className="col-12">
                            <h4>Pasoš:</h4>
                            </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="passportNumber">{t('nova.broj')}:</label>
                            <InputText id="passportNumber" name="passportNumber" type="number" value={formDataDocuments.passportNumber} onChange={handleChange} />
                        </div>      
                         <div className="col-12 md:col-6">
                            <label htmlFor="passportExpiry">{t('admin.datumVazenja')}:</label>
                            <Calendar id="passportExpiry" name="passportExpiry" value={formDataDocuments.passportExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                        </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="idSupPass">{t('admin.sup')}:</label>
                                <InputText id="idSupPas" name="idSupPass" value={formDataDocuments.idSupPass} onChange={handleChange} />
                            </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="docLK">{t('nova.dokument')}:</label>
                {!formDataDocumentsFILES.uploadedFilePASS ? <FileUpload
                                name="uploadedFilePASS"
                                className={buttonDocumentDB.uploadedFilePASS && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFilePASS ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFilePASS", e.files[0])}
                                />: <Button label={formDataDocumentsFILES.uploadedFilePASS.name} onClick={() => handleChangeDocUpload("uploadedFilePASS", null)} />}
                        </div>
                    </div>
                       <div className="red9 redDokument">
                             <div className="col-12">
                            <h4>VIZA:</h4>
                            </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="visaNumber">{t('nova.broj')}:</label>
                            <InputText id="visaNumber" name="visaNumber" type="text" value={formDataDocuments.visaNumber} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="visaExpiry">{t('admin.datumVazenja')}:</label>
                            <Calendar id="visaExpiry" name="visaExpiry" value={formDataDocuments.visaExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999" />
                        </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="docLK">{t('nova.dokument')}:</label>
              {!formDataDocumentsFILES.uploadedFileVIZA ? <FileUpload
                                name="uploadedFileVIZA"
                                className={buttonDocumentDB.uploadedFileVIZA && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileVIZA ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileVIZA", e.files[0])}
                                />: <Button label={formDataDocumentsFILES.uploadedFileVIZA.name} onClick={() => handleChangeDocUpload("uploadedFileVIZA", null)} />}
                        </div>
                    </div>
                    </div>
                </Card>
            </div>
                </AccordionTab>
                <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.cpc')}>
                    <div className="col-12 md:col-6">
                <Card>
                    <div className="gridDokumenti gridCPC">
                        <div className="red1 redDokument">
                            <div className="col-12">
                                <h4>{t('admin.cpc')}:</h4>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="cpcNumber">{t('nova.broj')}:</label>
                                <InputText id="cpcNumber" name="cpcNumber" value={formDataCPC.cpcNumber} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="cpcExpiry">{t('admin.datumVazenja')}:</label>
                                <Calendar id="cpcExpiry" name="cpcExpiry" value={formDataCPC.cpcExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="docCPC">{t('nova.dokument')}:</label>
                         {!formDataCPCFILES.uploadedFileCPC ? <FileUpload
                                name="uploadedFileCPC"
                                className={buttonDocumentDB.uploadedFileCPC && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileCPC ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileCPC", e.files[0])}
                                />: <Button label={formDataCPCFILES.uploadedFileCPC.name} onClick={() => handleChangeDocUpload("uploadedFileCPC", null)} />}
                            </div>
                        </div>
                          <div className="red3 redDokument">
                            <div className="col-12">
                                <h4>CPC potvrde:</h4>
                            </div>
                            <div id="CPCPotvrde" className='CPCPotvrde'>
                                <div>
                                    <h4>CPC seminar 1:</h4>
                                         <div className="col-12 md:col-6">
                                    <label htmlFor="cpcExpiryP1">{t('admin.datumVazenja')}:</label>
                                    <Calendar id="cpcExpiryP1" name="cpcExpiryP1" value={formDataCPC.cpcExpiryP1} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                                </div>
                                <div className="col-12 md:col-6">
                                    <label htmlFor="docCPC">{t('nova.dokument')}:</label>
                      {!formDataCPCFILES.uploadedFileCPCP1 ? <FileUpload
                                name="uploadedFileCPCP1"
                                className={buttonDocumentDB.uploadedFileCPCP1 && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileCPCP1 ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileCPCP1", e.files[0])}
                                />: <Button label={formDataCPCFILES.uploadedFileCPCP1.name} onClick={() => handleChangeDocUpload("uploadedFileCPCP1", null)} />}
                            </div>
                                </div>
                                <div>
                                    <h4>CPC seminar 2:</h4>
                                         <div className="col-12 md:col-6">
                                <label htmlFor="cpcExpiryP2">{t('admin.datumVazenja')}:</label>
                                <Calendar id="cpcExpiryP2" name="cpcExpiryP2" value={formDataCPC.cpcExpiryP2} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="docCPC">{t('nova.dokument')}:</label>
                       {!formDataCPCFILES.uploadedFileCPCP2 ? <FileUpload
                                name="uploadedFileCPCP2"
                                className={buttonDocumentDB.uploadedFileCPCP2 && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileCPCP2 ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileCPCP2", e.files[0])}
                                />: <Button label={formDataCPCFILES.uploadedFileCPCP2.name} onClick={() => handleChangeDocUpload("uploadedFileCPCP2", null)} />}
                            </div>
                                </div>
                                <div>
                                    <h4>CPC seminar 3:</h4>
                                                   <div className="col-12 md:col-6">
                                <label htmlFor="cpcExpiryP3">{t('admin.datumVazenja')}:</label>
                                <Calendar id="cpcExpiryP3" name="cpcExpiryP3" value={formDataCPC.cpcExpiryP3} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="docCPC">{t('nova.dokument')}:</label>
                         {!formDataCPCFILES.uploadedFileCPCP3 ? <FileUpload
                                name="uploadedFileCPCP3"
                                className={buttonDocumentDB.uploadedFileCPCP3 && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileCPCP3 ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileCPCP3", e.files[0])}
                                />: <Button label={formDataCPCFILES.uploadedFileCPCP3.name} onClick={() => handleChangeDocUpload("uploadedFileCPCP3", null)} />}
            
                            </div>
                                </div>
                                <div>
                                    <h4>CPC seminar 4:</h4>
                                                   <div className="col-12 md:col-6">
                                <label htmlFor="cpcExpiryP4">{t('admin.datumVazenja')}:</label>
                                <Calendar id="cpcExpiryP4" name="cpcExpiryP4" value={formDataCPC.cpcExpiryP4} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="docCPC">{t('nova.dokument')}:</label>
                      {!formDataCPCFILES.uploadedFileCPCP4 ? <FileUpload
                                name="uploadedFileCPCP4"
                                className={buttonDocumentDB.uploadedFileCPCP4 && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileCPCP4 ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileCPCP4", e.files[0])}
                                />: <Button label={formDataCPCFILES.uploadedFileCPCP4.name} onClick={() => handleChangeDocUpload("uploadedFileCPCP4", null)} />}
                            </div>
                                </div>
                                <div>
                                    <h4>CPC seminar 5:</h4>
                                                   <div className="col-12 md:col-6">
                                <label htmlFor="cpcExpiryP5">{t('admin.datumVazenja')}:</label>
                                <Calendar id="cpcExpiryP5" name="cpcExpiryP5" value={formDataCPC.cpcExpiryP5} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="docCPC">{t('nova.dokument')}:</label>
                       {!formDataCPCFILES.uploadedFileCPCP5 ? <FileUpload
                                name="uploadedFileCPCP5"
                                className={buttonDocumentDB.uploadedFileCPCP5 && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileCPCP5 ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileCPCP5", e.files[0])}
                                />: <Button label={formDataCPCFILES.uploadedFileCPCP5.name} onClick={() => handleChangeDocUpload("uploadedFileCPCP5", null)} />}
                            </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
            </div>
                </AccordionTab>
                <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.inostranaDok')}>
                   <div className="col-12 md:col-6">
                <Card>
                    <div className="gridDokumenti">
                        <div className="red1 redDokument"> 
                            <div className="col-12">
                                <h4>Lična karta:</h4>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="foreignIdCardNumber">{t('nova.broj')}:</label>
                                <InputText id="foreignIdCardNumber" name="foreignIdCardNumber" type="number" value={formDataForeign.foreignIdCardNumber} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="foreignIdCardExpiry">{t('admin.datumVazenja')}:</label>
                                <Calendar id="foreignIdCardExpiry" name="foreignIdCardExpiry" value={formDataForeign.foreignIdCardExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="foreignIdSup">{t('admin.sup')}:</label>
                                <InputText id="foreignIdSup" name="foreignIdSup" value={formDataForeign.foreignIdSup} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                            <label htmlFor="docLK">{t('nova.dokument')}:</label>
                                      {!formDataForeignFILES.foreignUploadedFileLK ? <FileUpload
                                name="foreignUploadedFileLK"
                                className={buttonDocumentDB.foreignUploadedFileLK && classDocumentDB}
                                chooseLabel={buttonDocumentDB.foreignUploadedFileLK ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("foreignUploadedFileLK", e.files[0])}
                                />: <Button label={formDataForeignFILES.foreignUploadedFileLK.name} onClick={() => handleChangeDocUpload("foreignUploadedFileLK", null)} />}

                            </div>
                        </div>            
                        <div className="red2 redDokument"> 
                            <div className="col-12">
                                <h4>Vozačka dozvola:</h4>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="foreignDrivingLicenseNumber">{t('nova.broj')}:</label>
                                <InputText id="foreignDrivingLicenseNumber" name="foreignDrivingLicenseNumber" type="number" value={formDataForeign.foreignDrivingLicenseNumber} onChange={handleChange} />
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="foreignDrivingLicenseExpiry">{t('admin.datumVazenja')}:</label>
                                <Calendar id="foreignDrivingLicenseExpiry" name="foreignDrivingLicenseExpiry" value={formDataForeign.foreignDrivingLicenseExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                            </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="foreignIdSupVD">{t('admin.sup')}:</label>
                                <InputText id="foreignIdSupVD" name="foreignIdSupVD" value={formDataForeign.foreignIdSupVD} onChange={handleChange} />
                            </div>
                            
                            <div className="col-12 flexColumn">
                                <label>{t('admin.kategorije')}:</label>
                                <div className="flex flex-wrap gap-3">
                                    {categories.map((category) => (
                                        <div key={category.code} className="flex align-items-center">
                                            <label htmlFor={category.code} className="ml-2">{category.name}:</label>
                                            <Checkbox inputId={category.code} name="foreignDrivingLicenseCategories" 
                                                value={category.code} onChange={handleCheckboxChangeForeign} 
                                                checked={formDataForeign.foreignDrivingLicenseCategories.includes(category.code)} />
                                        </div>
                                    ))}
                                </div>
                            </div>
                                <div className="col-12 md:col-6">
                                <label htmlFor="docVD">{t('nova.dokument')}:</label>
                       {!formDataForeignFILES.foreignUploadedFileVD ? <FileUpload
                                name="foreignUploadedFileVD"
                                className={buttonDocumentDB.foreignUploadedFileVD && classDocumentDB}
                                chooseLabel={buttonDocumentDB.foreignUploadedFileVD ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("foreignUploadedFileVD", e.files[0])}
                                />: <Button label={formDataForeignFILES.foreignUploadedFileVD.name} onClick={() => handleChangeDocUpload("foreignUploadedFileVD", null)} />}
                                    </div>
                        </div>
                        <div className="red8 redDokument">
                             <div className="col-12">
                            <h4>Pasoš:</h4>
                            </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="foreignPassportNumber">{t('nova.broj')}:</label>
                            <InputText id="foreignPassportNumber" name="foreignPassportNumber" type="text" value={formDataForeign.foreignPassportNumber} onChange={handleChange} />
                        </div>      
                         <div className="col-12 md:col-6">
                            <label htmlFor="foreignPassportExpiry">{t('admin.datumVazenja')}:</label>
                            <Calendar id="foreignPassportExpiry" name="foreignPassportExpiry" value={formDataForeign.foreignPassportExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                        </div>
                            <div className="col-12 md:col-6">
                                <label htmlFor="foreignIdSupPass">{t('admin.sup')}:</label>
                                <InputText id="foreignIdSupPass" name="foreignIdSupPass" value={formDataForeign.foreignIdSupPass} onChange={handleChange} />
                            </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="docLK">{t('nova.dokument')}:</label>
                        {!formDataForeignFILES.foreignUploadedFilePASS ? <FileUpload
                                name="foreignUploadedFilePASS"
                                className={buttonDocumentDB.foreignUploadedFilePASS && classDocumentDB}
                                chooseLabel={buttonDocumentDB.foreignUploadedFilePASS ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("foreignUploadedFilePASS", e.files[0])}
                                />: <Button label={formDataForeignFILES.foreignUploadedFilePASS.name} onClick={() => handleChangeDocUpload("foreignUploadedFilePASS", null)} />}
                        </div>
                    </div>
                       <div className="red3 redDokument">
                             <div className="col-12">
                            <h4>VIZA:</h4>
                            </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="foreignVisaNumber">{t('nova.broj')}:</label>
                            <InputText id="foreignVisaNumber" name="foreignVisaNumber" type="text" value={formDataForeign.foreignVisaNumber} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="foreignVisaExpiry">{t('admin.datumVazenja')}:</label>
                            <Calendar id="foreignVisaExpiry" name="foreignVisaExpiry" value={formDataForeign.foreignVisaExpiry} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                        </div>
                          <div className="col-12 md:col-6">
                            <label htmlFor="docLK">{t('nova.dokument')}:</label>
                       {!formDataForeignFILES.foreignUploadedFileVIZA ? <FileUpload
                                name="foreignUploadedFileVIZA"
                                className={buttonDocumentDB.foreignUploadedFileVIZA && classDocumentDB}
                                chooseLabel={buttonDocumentDB.foreignUploadedFileVIZA ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("foreignUploadedFileVIZA", e.files[0])}
                                />: <Button label={formDataForeignFILES.foreignUploadedFileVIZA.name} onClick={() => handleChangeDocUpload("foreignUploadedFileVIZA", null)} />}
                        </div>
                    </div>
                    </div>
                </Card>
            </div>
                </AccordionTab>
                <AccordionTab id="AccordionTabUnosZaposlenih" header={t('admin.podaciRadniOdnos')}>
                    <div className="col-12">
                <Card>
                    <div className="gridLicni">
                        <div className="col-12 md:col-4">
                            <label htmlFor="contractType">{t('admin.radniOdnos')}:</label>
                            <Dropdown placeholder={t('admin.phRadniOdnos')} id="contractType" name="contractType" required invalid={invalidControl(formDataEmployment.contractType)} value={formDataEmployment.contractType} 
                                options={radniOdnosOptions} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-4">
                             <label htmlFor="employmentStart">{t('admin.zapocetOd')}:</label>
                                    <Calendar id="employmentStart" name="employmentStart" value={formDataEmployment.employmentStart} required invalid={invalidControl(formDataEmployment.employmentStart)} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                        </div>
                        {formDataEmployment.contractType == 37 && <div className="col-12 md:col-4">
                             <label htmlFor="employmentEnd">{t('admin.zavrsenDo')}:</label>
                             {porukaTimeRange && <p class="infoPoruka" style={{fontSize: "10px"}}>{porukaTimeRange}</p>}
                                    <Calendar id="employmentEnd" name="employmentEnd" value={formDataEmployment.employmentEnd} required={formDataEmployment.contractType == 37} 
                                    invalid={formDataEmployment.contractType == 37 && invalidControl(formDataEmployment.employmentEnd)} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                        </div>}
                        <div className="col-12 md:col-4">
                            <label htmlFor="education">{t('admin.strucnaSprema')}:</label>
                            <Dropdown placeholder={t('admin.phStrucnuSpremu')} id="education" name="education" value={formDataEmployment.education}  required invalid={invalidControl(formDataEmployment.education)}
                                options={strucnaSpremaOptions} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="position">{t('admin.radnoMesto')}:</label>
                            <Dropdown placeholder={t('admin.phRadnoMesto')} id="position" required invalid={invalidControl(formDataEmployment.position)} name="position" value={formDataEmployment.position} 
                                options={pozicijaOptions} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-6">
                            <label htmlFor="additionalPosition">{t('admin.dodatnaFunkcija')}:</label>
                              <Dropdown placeholder={t('admin.phDodatnuFunkciju')} id="additionalPosition" name="additionalPosition" value={formDataEmployment.additionalPosition} 
                                options={pozicijaOptions} onChange={handleChange} />
                        </div>
                        <div className="col-12 md:col-4">
                            <label htmlFor="establishmentDate">{t('admin.datumZasnivanja')}:</label>
                            <Calendar id="establishmentDate" name="establishmentDate" value={formDataEmployment.establishmentDate} required invalid={invalidControl(formDataEmployment.establishmentDate)} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                        </div>
                        <div className="col-12 md:col-4">
                            <label htmlFor="terminationDate">{t('admin.datumOtkaza')}:</label>
                            <Calendar id="terminationDate" name="terminationDate" value={formDataEmployment.terminationDate} onChange={handleChange} showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                        </div>
                        <div className="col-12 md:col-4">
                            <label htmlFor="terminationReason">{t('admin.razlogPrestanka')}:</label>
                            <InputText id="terminationReason" name="terminationReason" value={formDataEmployment.terminationReason} onChange={handleChange} />
                        </div>
                        <div className="col-12">
                            <label htmlFor="notes">{t('nova.napomena')}:</label>
                            <InputText id="notes" name="notes" value={formDataEmployment.notes} onChange={handleChange} />
                        </div>
                        <div className="col-12">
                            <label htmlFor="stampa">{t('admin.stampaFormeUgovora')}:</label>
                            <Button label={t('admin.stampaUgovora')} onClick={handlePrintContract}  type='button' data-pr-tooltip={t('nova.stampa')} severity="secondary" />
                        </div>
                        <div className="col-12 md:col-4">
                                        <label htmlFor="contractNumber">{t('admin.brojUgovoraRed')}:</label>
                                        <InputNumber
                                          id="contractNumber"
                                          name="contractNumber"
                                          required
                                          invalid={invalidControl(formDataEmployment.contractNumber)}
                                          value={formDataEmployment.contractNumber}
                                          onValueChange={handleChange}
                                          min={1}
                                          step={1} />
                        </div>
                        <div className="col-12 md:col-4">
                             <label htmlFor="contractDate">{t('admin.poslednjiUgovor')}:</label>
                                    <Calendar id="contractDate" name="contractDate" value={formDataEmployment.contractDate} disabled showIcon dateFormat="dd.mm.yy" mask="99.99.9999"/>
                        </div>
                        <div className="col-12 md:col-4">
                                <label htmlFor="docCPC">{t('admin.ugovor')}:</label>
                       {!formDataEmploymentFILES.uploadedFileContract ? <FileUpload
                                name="uploadedFileContract"
                                className={buttonDocumentDB.uploadedFileContract && classDocumentDB}
                                chooseLabel={buttonDocumentDB.uploadedFileContract ? "Fajl u bazi!" : "Izaberi"}
                                customUpload={false}
                                auto={false}
                                uploadLabel="Pošalji"
                                mode="basic"
                                accept=".pdf,.jpg,.png"
                                maxFileSize={5000000}
                                onSelect={(e)=>handleChangeDocUpload("uploadedFileContract", e.files[0])}
                                />: <Button label={formDataEmploymentFILES.uploadedFileContract.name} onClick={() => handleChangeDocUpload("uploadedFileContract", null)} />}
                            </div>
                        {/* "Radi za firme" je operativna dozvola — da se vozač pojavi u
                            izborima druge firme i može na njene ture; nije radni odnos.
                            Ima smisla samo u krugu povezanih firmi (config.CompanyInCompany),
                            pa se ne prikazuje operateru koji ima samo svoju firmu.
                            RadiZaFirmeDB uvek sadrži i sopstvenu firmu — zato > 1. */}
                        {radiZaFirmeOptions.length > 1 && (
                        <div className="col-12">
                            <label htmlFor="companies">{t('admin.radiZaFirme')}:</label>
                            <MultiSelect
                                id="companies"
                                name="companies"
                                value={formDataEmployment.companies}
                                options={radiZaFirmeOptions}
                                optionLabel="label"
                                optionValue="value"
                                onChange={handleCompaniesChange}
                                display="chip"
                                placeholder={t('admin.phFirme')}
                                style={{ width: '100%' }} />
                            <small style={{ color: '#6c757d' }}>{t('admin.radiZaFirmeNapomena')}</small>
                        </div>
                        )}
                    </div>
                </Card>
            </div>
                </AccordionTab>
            </Accordion>
           
            
           <div className="formUnosZap buttonUnosZap">
              <button
                type="submit"
                onClick={handleFormSubmit}
                className="btn btn-success"
              >
                {izabran ? 'SAČUVAJ' : 'UNOS' }
              </button>
            </div>
            </form>
        </div>
    );
};

export default ZaposleniUnos;